import { render, staticRenderFns } from "./SQuesFortyTwo.vue?vue&type=template&id=42bff26e&"
import script from "./SQuesFortyTwo.vue?vue&type=script&lang=js&"
export * from "./SQuesFortyTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCardText,VDialog})
